module.exports = __webpack_public_path__ + "static/media/cam.911f46d2.png";